// Simple test page to see hybrid data in action
// Add this to your App.js routes for testing

import React, { useState, useEffect } from 'react';

function HybridDataTest() {
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);

  const cities = ['toronto', 'austin', 'new-york', 'boston', 'chicago', 'new-orleans'];

  const testCity = async (city) => {
    setLoading(true);
    try {
      const response = await fetch(`/api/chefs?city=${city}&status=approved,live&limit=10`);
      const data = await response.json();
      
      setResults(prev => ({
        ...prev,
        [city]: {
          real: data.results || [],
          total: data.count || 0,
          status: 'success'
        }
      }));
    } catch (error) {
      setResults(prev => ({
        ...prev,
        [city]: {
          error: error.message,
          status: 'error'
        }
      }));
    }
    setLoading(false);
  };

  const testAllCities = async () => {
    for (const city of cities) {
      await testCity(city);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>🧪 Hybrid Data System Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <button 
          onClick={testAllCities} 
          disabled={loading}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#9b1c18', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'Testing...' : 'Test All Cities'}
        </button>
      </div>

      {Object.entries(results).map(([city, data]) => (
        <div key={city} style={{ 
          marginBottom: '20px', 
          padding: '15px', 
          border: '1px solid #ddd', 
          borderRadius: '8px' 
        }}>
          <h3>📍 {city.charAt(0).toUpperCase() + city.slice(1)}</h3>
          
          {data.status === 'success' && (
            <div>
              <p><strong>Real chefs found:</strong> {data.total}</p>
              {data.real.length > 0 ? (
                <ul>
                  {data.real.map((chef, index) => (
                    <li key={index}>
                      <strong>{chef.name}</strong> 
                      {chef.photo_url && <span> 📸</span>}
                      <br />
                      <small>Status: {chef.status} | Created: {chef.created_at}</small>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No real chefs found - will show all demo chefs</p>
              )}
              
              <p><strong>Expected display:</strong> {data.total} real + {Math.max(0, 5 - data.total)} demo = 5 total</p>
            </div>
          )}
          
          {data.status === 'error' && (
            <p style={{ color: 'red' }}>Error: {data.error}</p>
          )}
        </div>
      ))}

      <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <h4>🎯 How the Hybrid System Works:</h4>
        <ol>
          <li><strong>Real chefs first:</strong> Shows uploaded chefs from database</li>
          <li><strong>Demo fillers:</strong> Adds demo chefs to reach 5 total per city</li>
          <li><strong>Visual badges:</strong> "Real Chef" for uploaded, "Demo" for placeholder</li>
          <li><strong>Clickable cards:</strong> All cards link to ChefDemo page</li>
        </ol>
        
        <p><strong>Current expectation:</strong> With 1 real upload + 7 seeded chefs, you should see a mix of real and demo data across cities.</p>
      </div>
    </div>
  );
}

export default HybridDataTest;
